import { JobProfileType } from 'Views/JobProfile/JobProfile.enums';
import { RiskType } from '../types/types';

export const postFormatter = (
	jobProfileType: JobProfileType,
	risk: RiskType,
) => {
	const addressParam = risk.address ? { address: risk.address } : {};
	return {
		name: risk.name,
		description: risk.description,
		jobRiskIds: risk.associatedRisk,
		...addressParam,
		type:
			jobProfileType === JobProfileType.RISK_PROFILE
				? 'riskProfile'
				: 'expositionArea',
	};
};

export const putFormmater = (
	jobProfileType: JobProfileType,
	risk: RiskType,
) => {
	const addressParam = risk.address ? { address: risk.address } : {};
	return {
		name: risk.name,
		description: risk.description,
		...addressParam,
	};
};
